import { accOpeningActions, localStateManagementActions } from '../../../shared/Actions';
import { connect } from 'react-redux';
import PhoneDetailsCardComponent from './PhoneDetailsCardComponent';

export const mapStateToProps = (state /* , props */) => ({
    accOpeningData: state.accOpeningReducerData,
    initialState: state.initialAppData,
    masterLookupStateData: state.masterLookUpData,
    localStateData: state.localStateManagementReducerData,
});

const mapDispatchToProps = {
    ...accOpeningActions,
    ...localStateManagementActions,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(PhoneDetailsCardComponent);
